import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 25px;
  background: #f3f3f5;
  border-bottom: 1px solid #b7b8c1;
  border-top: 1px solid #b7b8c1;
  height: 260px;
  box-sizing: border-box;
`

export const EmptyAwards = styled.div`
  text-align: center;
  font: var(--typography-21-26-regular);
  font-style: italic;
  color: var(--color-sw-60);
  width: 550px;
`

export const WineDescription = styled.div`
  font: var(--typography-22-28-semibold);
  font-style: italic;
  max-width: 580px;
  min-width: 130px;
  color: #717284;
  text-align: ${props => props.align};
  margin-left: ${props => (props.align === 'left' ? '70px' : 0)};
`
